import { useParams } from 'next/navigation'

import { useQuery } from '@tanstack/react-query'

import { ProductViewModel } from '@/types/api'

import { getPDPData } from './get-pdp-data'

import { PDPReactQueryKeys } from '../types'

export default function usePDPData(initialSlug?: string) {
    const params = useParams()

    let slug = ''

    if (initialSlug) {
        slug = initialSlug
    } else {
        slug = typeof params?.slug === 'string' ? params?.slug : (params?.slug?.at?.(0) as string)
    }

    return useQuery<ProductViewModel>({
        queryKey: [PDPReactQueryKeys.ProductData, { slug }],
        staleTime: Infinity,
        queryFn: () => getPDPData(slug),
        refetchOnMount: false,
        enabled: !!slug,
    })
}
